import React, { memo } from 'react'
import { Box, Card, Stack } from '@mui/material'

import CardHeading from '../shared/text/CardHeading'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import { faCoinFront } from '@fortawesome/pro-duotone-svg-icons'
import Text from '../shared/text/Text'
import { formatTicks } from '../../util/string.helpers'
import { getCoinsValues } from '../../util/game.helpers'

const Prizes = ({ t, symbol }) => {
  return (
    <Card sx={{ p: 3 }}>
      <CardHeading title={t('game.prizes')} desc={t('game.prizes-desc')} />
      <Stack spacing={1} alignItems='flex-start' justifyContent='center'>
        {getCoinsValues().map(({ count, value }) => (
          <Stack key={count} direction='row' spacing={0.6} alignItems='center'>
            {Array.from({ length: count === 0 ? 1 : count }, (_, i) => (
              <Box
                key={i}
                sx={{
                  height: 24,
                  color: count !== 0 && 'primary.main',
                  opacity: count === 0 && 0.5
                }}
              >
                <FaIcon icon={faCoinFront} fontSize={22} />
              </Box>
            ))}
            <Text
              label={`${count === 0 ? t('game.only-gray') : count} = ${formatTicks(value)} ${symbol}`}
            />
          </Stack>
        ))}
      </Stack>
    </Card>
  )
}

export default memo(Prizes)
